declare global {
  interface Window {
    gtag: (
      command: "config" | "event" | "js" | "set",
      targetId: string,
      config?: Record<string, unknown>,
    ) => void;
  }
}

export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GA_TRACKING_ID || "";

export const trackEvent = (
  eventName: string,
  eventParameters?: {
    event_category?: string;
    event_label?: string;
    value?: number;
    custom_parameters?: Record<string, string | number>;
  },
) => {
  if (!GA_TRACKING_ID || typeof window === "undefined") {
    return;
  }

  try {
    window.gtag("event", eventName, {
      event_category: eventParameters?.event_category || "engagement",
      event_label: eventParameters?.event_label,
      value: eventParameters?.value,
      ...eventParameters?.custom_parameters,
    });
  } catch (error) {
    console.warn("Analytics tracking failed:", error);
  }
};

export const trackButtonClick = (
  buttonText: string,
  buttonLocation: string,
  additionalData?: Record<string, string | number>,
) => {
  trackEvent("button_click", {
    event_label: `${buttonLocation}: ${buttonText}`,
    custom_parameters: {
      button_text: buttonText,
      button_location: buttonLocation,
      ...additionalData,
    },
  });
};

export const trackNavigationClick = (
  linkText: string,
  destination: string,
  linkLocation: string,
  additionalData?: Record<string, string | number>,
) => {
  trackEvent("navigation_click", {
    event_label: `${linkLocation}: ${linkText} -> ${destination}`,
    custom_parameters: {
      link_text: linkText,
      destination,
      link_location: linkLocation,
      ...additionalData,
    },
  });
};

export const trackPageView = (url: string, title?: string) => {
  if (!GA_TRACKING_ID || typeof window === "undefined") {
    return;
  }

  try {
    window.gtag("config", GA_TRACKING_ID, {
      page_title: title,
      page_location: url,
    });
  } catch (error) {
    console.warn("Page view tracking failed:", error);
  }
};
